import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import { isFieldInUse } from '@user/store/customFields'

type State = {
  loading: boolean
  deleteId?: number
  usageCount?: number
}

export type DeleteProps = ReturnType<typeof useDelete>

export function useDelete() {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({ loading: false }))

  const openDelete = useCallback(
    async (deleteId: number) => {
      setState({ deleteId, loading: true })

      const result = await dispatch(isFieldInUse(deleteId))

      if (isFieldInUse.fulfilled.match(result)) {
        setState({
          deleteId,
          loading: false,
          usageCount: result.payload,
        })
      } else {
        setState({
          deleteId,
          loading: false,
        })
      }
    },
    [dispatch],
  )

  const closeDelete = useCallback(
    () => setState((s) => ({ ...s, deleteId: undefined })),
    [],
  )

  const onTransitionEnd = useCallback(
    () =>
      setState((s) => {
        if (!!s.deleteId) return s
        return { loading: false }
      }),
    [],
  )

  return {
    ...state,
    openDelete,
    closeDelete,
    onTransitionEnd,
  }
}
